import { TabContext, TabList, TabPanel } from "@mui/lab"
import { Section } from "./StyledSystemManagementLearn"
import { Box } from "@mui/system"
import { Tab } from "@mui/material"
import HookSystemManagementLearn from '../../../hooks/hook-SystemManagementLearn';
import Inprogress from './InProgrres';
import NotActive from './NotActive';
import Complected from "./Completed";
const SystemManagementLearn = () => {
    const { value, handleChange } = HookSystemManagementLearn()
    return (
        <Section>
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange} aria-label="lab API tabs example">
                        <Tab value="1" label=' قيد التقدم' />
                        <Tab value="2" label=' أنجزت' />
                        <Tab value="3" label=' غير نشطة' />
                    </TabList>
                </Box>
                <TabPanel value="1">
                    <Inprogress />
                </TabPanel>
                <TabPanel value="2">
                    <Complected />
                </TabPanel>
                <TabPanel value="3">
                    <NotActive />
                </TabPanel>
            </TabContext>
        </Section>
    )
}
export default SystemManagementLearn